"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShouldCache = void 0;
function ShouldCache(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== 'function') {
        throw new TypeError(`Only methods can be decorated with @ShouldCache. <${propertyKey}> is not a method!`);
    }
    const cacheSupportTarget = target;
    if (!cacheSupportTarget.__shouldCache) {
        cacheSupportTarget.__shouldCache = new Set();
    }
    cacheSupportTarget.__shouldCache.add(propertyKey);
    return descriptor;
}
exports.ShouldCache = ShouldCache;
//# sourceMappingURL=should-cache.decorator.js.map